import React from "react";
import MonthYearPicker from "../component-tools/MonthYearPicker";
import { getStates } from "../../services/helpers";

export interface Education {
  educationName: string;
  highestDegree: string;
  degreeDate: Date;
  city: string;
  state: string;
  country: string;
}

interface EducationProps {
  education: Education;
  validationErrors: { [key: string]: string };
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index: number
  ) => void;
  onDelete: () => void;
  index: number;
  oneEducation: boolean;
}

const EducationForm: React.FC<EducationProps> = ({
  education,
  validationErrors,
  onInputChange,
  onDelete,
  index,
  oneEducation,
}) => {
  const states = getStates();
  return (
    <div className="data-container">
      <div className="text-sub-sub-header" style={{ flex: "0 0 100%" }}>
        {oneEducation
          ? "Educational Institution"
          : `Educational Institution #${index + 1}`}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">Name of Educational Institution:</label>
        <div className="field-input">
          <input
            className={`form-control ${
              validationErrors[`educationName-${index}`] ? "is-invalid" : ""
            }`}
            type="text"
            value={education.educationName || ""}
            onChange={(e) => onInputChange(e, "educationName", index)}
          />
          {validationErrors[`educationName-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`educationName-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">Degree Received:</label>
        <div className="field-input">
          <input
            className={`form-control ${
              validationErrors[`highestDegree-${index}`] ? "is-invalid" : ""
            }`}
            type="text"
            value={education.highestDegree || ""}
            onChange={(e) => onInputChange(e, "highestDegree", index)}
          />
          {validationErrors[`highestDegree-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`highestDegree-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">Degree Date:</label>
        <MonthYearPicker
          value={education.degreeDate}
          onChange={(newDate) =>
            onInputChange(
              { target: { value: newDate } } as any,
              "degreeDate",
              index
            )
          }
        />
        {validationErrors[`degreeDate-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`degreeDate-${index}`]}
          </div>
        )}
      </div>

      <div className="field-stacked" style={{ flex: "0 0 30%" }}>
        <label className="field-label">City:</label>
        <div className="field-input">
          <input
            className={`form-control ${
              validationErrors[`city-${index}`] ? "is-invalid" : ""
            }`}
            type="text"
            value={education.city || ""}
            onChange={(e) => onInputChange(e, "city", index)}
          />
          {validationErrors[`city-${index}`] && (
            <div className="invalid-feedback">
              {validationErrors[`city-${index}`]}
            </div>
          )}
        </div>
      </div>

      <div className="field-stacked" style={{ flex: "0 0 20%" }}>
        <label className="field-label">State:</label>
        <select
          className={`form-select ${
            validationErrors[`state-${index}`] ? "is-invalid" : ""
          }`}
          value={education.state || ""}
          onChange={(e) => onInputChange(e, "state", index)}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.abbreviation} value={state.abbreviation}>
              {state.name} ({state.abbreviation})
            </option>
          ))}
        </select>
        {validationErrors[`state-${index}`] && (
          <div className="invalid-feedback">
            {validationErrors[`state-${index}`]}
          </div>
        )}
      </div>

      {education.state === "INT" && (
        <div className="field-stacked" style={{ flex: "0 0 20%" }}>
          <label className="field-label">Country:</label>
          <div className="field-input">
            <input
              className="form-control"
              type="text"
              value={education.country ? education.country : ""}
              onChange={(e) => onInputChange(e, "country", index)}
            />
          </div>
        </div>
      )}

      {!oneEducation && (
        <div style={{ flex: "0 0 100%" }}>
          <button className="oxbtn btn-red" onClick={onDelete}>
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default EducationForm;
